export default "__VITE_ASSET__CDVAqI7A__"